<template>
  <div class="book">
    <div class="container btnP searchDV text-center pt-2">
        
      <button class="btn btn-info btnP" @click="prt()">طباعة</button>
    </div>

    <div class="page1" v-for="itm in lng" :key="itm">
      <div class="subpage">
        <header class="row">
          <div class="col-4 pt-4">
            شركة الصافنات للنقل
          </div>
          <div class="col-4">
            <p class="text-center">بسم الله الرحمن الرحيم</p>
            <p class="text-center">تقرير عن مجموع الاشتراكات</p>
            <p class="text-center">{{ classyearsN}}</p>
          </div>
          <div class="col-4 text-left">
            <img src="../../../public/static/img/logo.png" alt="" />
          </div>
        </header>
        <div class="bd">
          <table class="table">
            <thead>
              <tr>
                <th>م</th>
                <th>كود الحافلة</th>
                <th>اسم السائق</th>
                <th>قيمة الاشتراكات</th>
                <th>القيمة المضافة</th>
                <th>صافى الاشتراكات</th>
                <th>المبالغ الواردة</th>
                <th>المديونيات</th>
                <th>القيمة المضافة الواردة</th>
              </tr>
            </thead>
            <tbody>
                
              <tr v-for="rw in cunt" :key="rw" >
             
                <td >{{ inx }}</td>
                <td>{{ loadsub[indx].busid}}</td> 
                <td>{{ loadsub[indx].driver}}</td>
                <td>{{ loadsub[indx].totalSub}}</td>
                <td>{{ loadsub[indx].addTax}}</td>
                <td>{{ loadsub[indx].subTotal}}</td>
                <td>{{ loadsub[indx].income}}</td>
                <td>{{ loadsub[indx].depits}}</td>
                <td>{{ loadsub[indx].addTaxincome}}</td>

                {{
                   addnum(indx, itm) 

                }}
                <!-- <td v-if="addnum()" ></td> -->
              </tr>
            </tbody>
          </table>
        </div>
        <footer class="row">
          <div class="col-4">
            <span>رقم الصفحة </span>
            <span>{{ itm }}</span>
            <span> | </span>
            <span> {{ lng }} </span>
          </div>
          <div class="col-4 "></div>
          <div class="col-4">
            <span>التاريخ</span>
            <span> / </span>
            <span>{{dt}} </span>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import reportsLayout from "../../layouts/reportsLayout.vue";
import $ from "jquery";
export default {
  name: "driverR",
  data() {
    return {
      lng: 0,
      datalng: 0,
      cunt: 10,
      indx: 0,
      kwd: 0,
      dt:'',
      inx:1,
      sst:'',
      ppt:'',
      loadsub:[],
    };
  },
  props:['classyearsID','classyearsN'],
  computed: {
    ...mapGetters({
      std: "stdMod/GET_STDALL",
      payment: "payMod/GET_ALLDATA",
      emp: "empMod/GET_ALLDATA",
      bus: "busMod/GET_ALLDATA",
      staticV: "GET_STATICVALUE",

    }),
  },
 async created() {
    this.$emit("update:layout", reportsLayout);
    await this.LoadData();
    this.loadDate();
    this.reportLoad();
  },
  methods: {
   
    LoadData() {
        var driver = '';
        var totalSub = 0;
        var addTax =0;
        var subTotal= 0;
        var income=0;
        var depits=0;
        var addTaxincome = 0;
        
        /*for loop */

        
        /* */
        if(this.bus != null){
          const vm = this;
          let list=[];
            $.each(this.bus, function () {
           var idd = this.id;
            var empp = vm.emp.find((t)=>t.id == this.ownerBus);
            driver = empp.Fname +' '+empp.Ffname;
          //  this.sst = student(busid);
            totalSub = vm.studentF(idd);
            // this.ppt = paymt(busid);
            income = vm.paymt(idd);
            var addTaxx = vm.staticV.find((t)=>t.id == 1);
            addTax =Math.round(totalSub > 0 ? (totalSub * addTaxx.amount)/100 : 0,1);
            subTotal = totalSub - addTax;
            depits = subTotal - income;
            addTaxincome = income > 0 ? (income * addTaxx.amount)/100 : 0;

           list.push({
               "busid":idd,
               "driver":driver,
               "totalSub":totalSub,
               "addTax":addTax,
               "subTotal":subTotal,
               "income":income,
               "depits":depits,
               "addTaxincome":addTaxincome

           });
           });
        this.loadsub = list;
        } 
        
        
    },
     studentF(busId){
        var sumT=0;
            var ld= this.std.filter((t)=>t.busCode == busId && t.classyears == this.classyearsID);
            $.each(ld, function () {
               sumT += parseFloat(this.AmountSub);
            });
            return sumT;
    },paymt(busId){
        var payT=0;
           var kk = this.payment.filter((t)=>t.busID == busId && t.classyears == this.classyearsID);
              $.each(kk, function () {
               payT += parseFloat(this.amount);
            });
            return payT;
    },
    reportLoad() {
      if (this.loadsub != null) {
        this.indx = this.loadsub.length - 1;
        var lln = Math.floor(this.loadsub.length / this.cunt);
        if (lln < 1) {
          this.cunt = this.loadsub.length ;
          this.lng = 1;
        } else {
          this.lng = Math.ceil(this.loadsub.length / this.cunt);
          var ss = this.cunt * lln;
          this.kwd = this.loadsub.length - ss;
        }
       
        //window.print();
      }
    }, addnum: function(indx, itm) {
      
     this.inx += 1; 

    this.indx = this.indx - 1 
    
      if (itm == this.lng) {

        if (this.kwd > 1) {
            
          if (this.indx == this.kwd - 1) {
           
           this.cunt = this.indx;
          }

        } else if(this.kwd == 1) {

          if (this.indx == 1) {
            this.cunt = 1;
          }
          
        }
      }
      /* var chk = this.loadsub[indx].id;
      if(chk == 'undefind'){
      this.indx = chkV;
      } */
    },
    prt() {
      window.print();
    },
    loadDate(){
      const event = new Date();
       const options = {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric"
        }
     this.dt = event.toLocaleDateString('ar-SA', options);
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../public/static/css/print.css";
.searchDV {
  height: 50px;
  width: 790px;
  background-color: white;
}
.bd {
  height: 940px;
}
thead{
 background-color: #d4d4d4; 
}
</style>
